import { TableHeader } from '../../common/GoldTable/GoldColumns';
import { GOLD_DATA } from '../../common/types';
import { Row } from 'react-table';
import { capitalized } from '../../common/utils';
import { addCommasToNumber } from '../../../Utils/CommonUtils';

interface CityComparisonColumnType {
  Header: string | JSX.Element;
  accessor: string;
  Cell: ({ row }: { row: Row<GOLD_DATA> }) => JSX.Element;
}

export const CITY_COMPARISON_COLUMNS: CityComparisonColumnType[] = [
  {
    Header: <TableHeader text="City" />,
    accessor: 'city',
    Cell: ({ row }: { row: Row<GOLD_DATA> }) => {
      return (
        <a
          href={`/gold-rate-${row.original.city.toLowerCase()}`}
          className="text-s-14 font-semibold capitalize text-blue-350 hover:underline"
        >
          {capitalized(row.original.city)}
        </a>
      );
    },
  },
  {
    Header: <TableHeader text="24K (10g)" />,
    accessor: 'carat24',
    Cell: ({ row }: { row: Row<GOLD_DATA> }) => {
      const rate = Math.floor(row.original.carat24.ratePerGram * 10);
      return <span className="text-s-14">₹{addCommasToNumber(rate)}</span>;
    },
  },
  {
    Header: <TableHeader text="22K (10g)" />,
    accessor: 'carat22',
    Cell: ({ row }: { row: Row<GOLD_DATA> }) => {
      const rate = Math.floor(row.original.carat22.ratePerGram * 10);
      return <span className="text-s-14">₹{addCommasToNumber(rate)}</span>;
    },
  },
  {
    Header: <TableHeader text="18K (10g)" />,
    accessor: 'carat18',
    Cell: ({ row }: { row: Row<GOLD_DATA> }) => {
      const rate = Math.floor(row.original.carat18.ratePerGram * 10);
      return <span className="text-s-14">₹{addCommasToNumber(rate)}</span>;
    },
  },
  {
    Header: <TableHeader text="14K (10g)" />,
    accessor: 'carat14',
    Cell: ({ row }: { row: Row<GOLD_DATA> }) => {
      const rate = Math.floor(row.original.carat14.ratePerGram * 10);
      return <span className="text-s-14">₹{addCommasToNumber(rate)}</span>;
    },
  },
  {
    Header: <TableHeader text="12K (10g)" />,
    accessor: 'carat12',
    Cell: ({ row }: { row: Row<GOLD_DATA> }) => {
      const rate = Math.floor(row.original.carat12.ratePerGram * 10);
      return <span className="text-s-14">₹{addCommasToNumber(rate)}</span>;
    },
  },
  {
    Header: <TableHeader text="9K (10g)" />,
    accessor: 'carat9',
    Cell: ({ row }: { row: Row<GOLD_DATA> }) => {
      const rate = Math.floor(row.original.carat9.ratePerGram * 10);
      return <span className="text-s-14">₹{addCommasToNumber(rate)}</span>;
    },
  },
];
